import search from "../assets/search.png";
import add from "../assets/add.png";
import {useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import teams_api from "../api/protected/teams"
import TeamsGridContainer from "../containers/TeamsGridContainer";
import NewTeam from "../components/teams/NewTeam";
import {useNavigate} from "react-router-dom";
import Slider from "../components/Slider";
import plus from "../assets/add.png";
import InfoRightPopUp from "../components/InfoRightPopUp";
import VerifyEmailPopup from "../components/VerifyEmailPopup";
import dashboard_api from "../api/protected/dashboard";


const Teams = () => {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams();
    const [showHidden, setShowHidden] = useState(false);

    const [teams, setTeams] = useState([]);
    const [userTeams, setUserTeams] = useState([]);
    const [demoTeams, setDemoTeams] = useState([]);
    const [showNewTeam, setShowNewTeam] = useState(false)
    const [searchTerm, setSearchTerm] = useState('')

    const [params] = useSearchParams();
    const [searchName, setSearchName] = useState("")
    const [organisationId, setOrganisationId] = useState(0)

    const [showTitleHover, setShowTitleHover] = useState(false)
    const titleDescription = ["Teams - Team Participants, Surveys and Reports.", "Either select from the list below or use the Plus icon to create a new Team."]
    const titlePopupStyle = {top: 35, left: 140}

    useEffect(() => {
        getTeams()
    }, [])

    useEffect(() => {
        if (params.get('name') !== null) {
            let _name = params.get('name')
            setSearchName(_name)
            setShowNewTeam(true)
        }
        if (params.get('organisation') !== null) {
            let _id = params.get('organisation')
            setOrganisationId(_id)
        }
    }, []);

    useEffect(() => {
        setTeams([...demoTeams, ...userTeams])
    }, [demoTeams, userTeams]);

    useEffect(() => {
        if (searchParams.get("new") === "1"){
            setShowNewTeam(true)
            setSearchParams({});
        };

    })

    const [showVerifyEmailPopup, setShowVerifyEmailPopup] = useState(false);
    useEffect(() => {
        dashboard_api.getValidateEmail().then((response) => {
            const isAlreadyVerified = response.data === 1;

            if (!isAlreadyVerified) {
                setShowVerifyEmailPopup(true)
                console.log("You are not verified. Please click the link in your email.")
            } else {
                setShowVerifyEmailPopup(false)
                console.log("You are verified. Please carry on.")
            }
        })
    }, []);

    const handleEditTeam = (team) => {
        if (!team) return;
        if(team.demo) {
            navigate(`/teams/${team.id}?demo=true`)
        } else {
            navigate(`/teams/${team.id}`)
        }
    }

    const hideNewTeamForm = () => {
        getTeams()
        setSearchName("")
        setShowNewTeam(false)
    }

    const getTeams = () => {
        let response = teams_api.getTeams();
        response.then(response => {
            setUserTeams(response.data.teams);
        })
        response = teams_api.getDemoTeams();
        response.then(response => {
            setDemoTeams(response.data.teams)
        })
    }

    const updateToggleHidden = () => {
        setShowHidden(!showHidden);
    }

    return (
        <div className="teams-page-background-container">
            <div className="teams-page-container">
                {showNewTeam ?
                    <NewTeam updateTeamsGrid={hideNewTeamForm.bind(this)} searchName={searchName} organisationId={organisationId}/>
                    :
                    <>
                        <div className="teams-page-header">
                            <div className="page-header-title-container">
                                <div className="teams-page-title">
                                    Teams
                                </div>
                                <InfoRightPopUp top={35} left={140} text={<>
                                    <div className="title-description-popup-text">
                                        Use this page to create and manage Teams - Team Participants, Surveys and Reports.
                                    </div>
                                    <div className="title-description-popup-text">
                                        Either select from the list below or use the <img src={plus} alt="+"/> icon to
                                        create a new Team.
                                    </div>
                                </>} />
                            </div>
                            <div className="teams-page-search-container">
                                <input type="text" placeholder="Search" value={searchTerm}
                                       onChange={(ev) => setSearchTerm(ev.target.value)}
                                       onKeyUp={(ev) => {
                                           if (ev.key === 'Enter') navigate("/search?term=" + searchTerm)
                                       }}
                                />
                                <img src={search} alt="search icon" className="link"/>
                            </div>
                        </div>
                        <div className="page-actions-container">
                            <div className="page-toggle-hidden">
                                <Slider update={updateToggleHidden.bind(this)} state={showHidden}/>
                            </div>
                            <div className="toggle-hidden-text">Show hidden</div>
                            <div className="teams-page-add-container">
                                <img src={add} alt="add icon" className="link"
                                     onClick={() => setShowNewTeam(true)}/>
                            </div>
                        </div>
                        <TeamsGridContainer teams={teams} showHidden={showHidden} handleClick={handleEditTeam.bind(this)}/>
                    </>
                }
                {showVerifyEmailPopup && showVerifyEmailPopup ?
                    <VerifyEmailPopup wide={false} /> : null }
            </div>
        </div>
    )
}

export default Teams
